<template>
  <div class="luckdraw-module">
    <div class="k-luckdraw" ref="luckdraw" :style="aStyle">
      <div
        class="lottery-num"
        :style="{
          fontSize: `${$unit(num.fontSize)}`,
          color: `${num.fontColor}`,
          bottom: `${$unit(num.bottom)}`
        }"
      >
        剩余{{ prizeNum || 0 }}次抽奖机会
      </div>
      <div
        class="btn-history"
        :style="{
          fontSize: `${$unit(history.fontSize)}`,
          color: `${history.fontColor}`,
          bottom: `${$unit(history.bottom)}`
        }"
        @click="openPrizeRecord"
      >
        查看中奖记录
      </div>
      <base-luckdraw
        class="wrapper"
        ref="luckDrawPrize"
        :style="{
          bottom: `${$unit(draw.bgBottom)}`
        }"
        :prize-list="list"
        :turns-number="turnsNumber"
        :turns-time="turnsTime"
        :prize-index="prizeIndex"
        :draw="draw"
        @end-turns="endTurns"
        @start-turns="startTurns"
      >
        <template slot="item" slot-scope="scope">
          <div class="drawTable-img">
            <img :src="scope.item.prizeImg" />
          </div>
          <div class="drawTable-name">{{ scope.item.prizeName }}</div></template
        ></base-luckdraw
      >
    </div>
    <div class="marquee-box" :style="pStyle" v-if="marquee.scrollSwitch">
      <div
        class="marquee-scroll"
        :style="{
          bottom: `${$unit(marquee.bottom)}`
        }"
      >
        <scroll-marquee
          :speed="10"
          :standTime="2000"
          :list="scrollPrizes"
          :marquee="marquee"
        >
        </scroll-marquee>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseLuckdraw from './BaseLuckdraw.vue';
import ScrollMarquee from './ScrollMarquee.vue';
export default {
  components: { BaseLuckdraw, ScrollMarquee },
  name: 'McLuckdraw',

  props: {
    imageValue: {
      type: Object,
      default: () => {}
    },
    draw: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    },
    view: {
      type: Object,
      default: () => {}
    },
    marquee: {
      type: Object,
      default: () => {}
    },
    num: {
      type: Object,
      default: () => {}
    },
    history: {
      type: Object,
      default: () => {}
    },
    drawNumber: {
      type: Number,
      default: () => null
    },
    moduleId: {
      type: Number
    },
    viewStatus: {
      type: Number
    }
  },

  data() {
    return {
      height: 1220,
      pHeight: 200,
      defaultModuleBg:
        'https://yxfile.3k.com/2023/03/14/upload_w0u28yhqzzpakd8ejkcxgikvo6gsw2ad.jpg',
      defaultMarquee:
        'https://yxfile.3k.com/2023/03/15/upload_jmh38yz8aqyoiya0cxgmggcingwn63me.jpg',
      // 中奖的奖品的index(此数据可根据后台返回的值重新赋值)
      prizeIndex: -1,
      // 用来锁定转盘，避免同时多次点击转动
      prizeNum: 0,
      lock: false,
      // 转动圈数
      turnsNumber: 5,
      // 转动需要持续的时间(秒)
      turnsTime: 5,
      scrollPrizes: []
    };
  },
  computed: {
    state() {
      return this.$store.state;
    },
    ...mapGetters(['prize']),
    aStyle() {
      return {
        height: this.$unit(this.height),
        backgroundImage: `url(${
          this.imageValue.imagePath || this.defaultModuleBg
        })`
      };
    },
    pStyle() {
      return {
        height: this.$unit(this.pHeight),
        backgroundImage: `url(${this.marquee.scrollBg || this.defaultMarquee})`
      };
    }
  },
  watch: {
    imageValue() {
      this.init();
    },
    marquee() {
      this.initMarquee();
    },
    'view.ext_params.draw_number': {
      deep: true,
      handler() {
        this.prizeNum = this.view.ext_params.draw_number;
      }
    }
  },
  mounted() {
    this.init();
    this.initMarquee();
    if (this.viewStatus == 2) {
      this.prizeNum = this.drawNumber;
      if (this.marquee.scrollSwitch) {
        this.getModulePrizeRecord();
      }
    } else {
      this.scrollPrizes = [
        { role_name: '测试用户1', prize_name: '测试奖品1' },
        { role_name: '测试用户2', prize_name: '测试奖品2' }
      ];
    }
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.height = h;
      };
      img.src = this.imageValue.imagePath;
    },
    initMarquee() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.pHeight = h;
      };
      img.src = this.marquee.scrollBg;
    },
    // 查看中奖记录
    openPrizeRecord() {
      if (this.viewStatus == 2) {
        if (this.state.userInfo.guid == '') {
          this.$store.commit('OPEN_DIALOG', 'Guid');
        } else {
          this.$store.commit('UPDATE_MODULE_ID', this.moduleId);
          this.$store.commit('OPEN_DIALOG', 'PrizeRecord');
        }
      }
    },
    // 获取活动模块中奖记录
    async getModulePrizeRecord() {
      let { code, data } = await this.$api.prize.getModulePrizeRecord({
        module_id: this.moduleId
      });
      if (code !== 0) return;
      this.scrollPrizes = data;
    },
    // 开始抽奖
    startTurns() {
      if (this.viewStatus != 2) return;
      if (this.state.userInfo.guid === '') {
        this.$store.commit('OPEN_DIALOG', 'Guid');
        return false;
      }
      // 如果还不可以转动
      if (!this.canBeRotated()) {
        return false;
      }
      // 开始转动
      // 先上锁
      this.lock = true;
      this.drawPrize();
    },
    //请求服务端抽奖
    async drawPrize() {
      let { code, data } = await this.$api.prize.drawPrize({
        module_id: this.moduleId,
        guid: this.state.userInfo.guid,
        server_id: this.state.userInfo.server_id,
        role_id: this.state.userInfo.role_id
      });
      if (code !== 0) {
        this.lock = false;
        return;
      }
      this.Track(4, this.moduleId);
      this.$store.commit('UPDATE_PRIZE', data);
      this.getPrizeIndex();
      // 成功后次数减少一次
      this.prizeNum--;
    },
    //获取中奖奖品的索引
    getPrizeIndex() {
      this.list.forEach((item, index) => {
        if (item.prize_id === this.prize.prize_id) {
          this.prizeIndex = index;
          // 告诉子组件，开始转动了
          this.$refs.luckDrawPrize.rotate(index);
        }
      });
    },
    // 已经转动完转盘触发的函数
    endTurns() {
      // 中奖
      this.$store.commit('OPEN_DIALOG', 'Prize');
      // 解锁
      this.lock = false;
      //更新中奖播报
      if (this.marquee.scrollSwitch) {
        this.getModulePrizeRecord();
      }
    },
    // 判断是否可以转动
    canBeRotated() {
      if (this.prizeNum <= 0) {
        this.toast('已经没有次数了！');
        return false;
      }
      if (this.lock) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.k-luckdraw {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 499;
}
.lottery-num {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 150px;
  font-size: 22px;
  color: #e5e5e5;
  text-align: center;
}
.btn-history {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 60px;
  font-size: 22px;
  color: #f8db83;
  text-align: center;
  text-decoration: underline;
}
.marquee-box {
  position: relative;
  height: 200px;
  background-size: cover;
  background-repeat: no-repeat;
  .marquee-scroll {
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 50px;
  }
}
</style>
